module.exports = __webpack_public_path__ + "static/fleur_small-4fc851960276205d0a2f23a4334ccc8c.jpg";